function _array_like_to_array(arr, len) {
    if (len == null || len > arr.length) len = arr.length;
    for(var i = 0, arr2 = new Array(len); i < len; i++)arr2[i] = arr[i];
    return arr2;
}
function _array_with_holes(arr) {
    if (Array.isArray(arr)) return arr;
}
function asyncGeneratorStep(gen, resolve, reject, _next, _throw, key, arg) {
    try {
        var info = gen[key](arg);
        var value = info.value;
    } catch (error) {
        reject(error);
        return;
    }
    if (info.done) {
        resolve(value);
    } else {
        Promise.resolve(value).then(_next, _throw);
    }
}
function _async_to_generator(fn) {
    return function() {
        var self = this, args = arguments;
        return new Promise(function(resolve, reject) {
            var gen = fn.apply(self, args);
            function _next(value) {
                asyncGeneratorStep(gen, resolve, reject, _next, _throw, "next", value);
            }
            function _throw(err) {
                asyncGeneratorStep(gen, resolve, reject, _next, _throw, "throw", err);
            }
            _next(undefined);
        });
    };
}
function _class_call_check(instance, Constructor) {
    if (!(instance instanceof Constructor)) {
        throw new TypeError("Cannot call a class as a function");
    }
}
function _defineProperties(target, props) {
    for(var i = 0; i < props.length; i++){
        var descriptor = props[i];
        descriptor.enumerable = descriptor.enumerable || false;
        descriptor.configurable = true;
        if ("value" in descriptor) descriptor.writable = true;
        Object.defineProperty(target, descriptor.key, descriptor);
    }
}
function _create_class(Constructor, protoProps, staticProps) {
    if (protoProps) _defineProperties(Constructor.prototype, protoProps);
    if (staticProps) _defineProperties(Constructor, staticProps);
    return Constructor;
}
function _define_property(obj, key, value) {
    if (key in obj) {
        Object.defineProperty(obj, key, {
            value: value,
            enumerable: true,
            configurable: true,
            writable: true
        });
    } else {
        obj[key] = value;
    }
    return obj;
}
function _iterable_to_array_limit(arr, i) {
    var _i = arr == null ? null : typeof Symbol !== "undefined" && arr[Symbol.iterator] || arr["@@iterator"];
    if (_i == null) return;
    var _arr = [];
    var _n = true;
    var _d = false;
    var _s, _e;
    try {
        for(_i = _i.call(arr); !(_n = (_s = _i.next()).done); _n = true){
            _arr.push(_s.value);
            if (i && _arr.length === i) break;
        }
    } catch (err) {
        _d = true;
        _e = err;
    } finally{
        try {
            if (!_n && _i["return"] != null) _i["return"]();
        } finally{
            if (_d) throw _e;
        }
    }
    return _arr;
}
function _non_iterable_rest() {
    throw new TypeError("Invalid attempt to destructure non-iterable instance.\\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method.");
}
function _object_spread(target) {
    for(var i = 1; i < arguments.length; i++){
        var source = arguments[i] != null ? arguments[i] : {};
        var ownKeys = Object.keys(source);
        if (typeof Object.getOwnPropertySymbols === "function") {
            ownKeys = ownKeys.concat(Object.getOwnPropertySymbols(source).filter(function(sym) {
                return Object.getOwnPropertyDescriptor(source, sym).enumerable;
            }));
        }
        ownKeys.forEach(function(key) {
            _define_property(target, key, source[key]);
        });
    }
    return target;
}
function ownKeys(object, enumerableOnly) {
    var keys = Object.keys(object);
    if (Object.getOwnPropertySymbols) {
        var symbols = Object.getOwnPropertySymbols(object);
        if (enumerableOnly) {
            symbols = symbols.filter(function(sym) {
                return Object.getOwnPropertyDescriptor(object, sym).enumerable;
            });
        }
        keys.push.apply(keys, symbols);
    }
    return keys;
}
function _object_spread_props(target, source) {
    source = source != null ? source : {};
    if (Object.getOwnPropertyDescriptors) {
        Object.defineProperties(target, Object.getOwnPropertyDescriptors(source));
    } else {
        ownKeys(Object(source)).forEach(function(key) {
            Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key));
        });
    }
    return target;
}
function _object_without_properties(source, excluded) {
    if (source == null) return {};
    var target = _object_without_properties_loose(source, excluded);
    var key, i;
    if (Object.getOwnPropertySymbols) {
        var sourceSymbolKeys = Object.getOwnPropertySymbols(source);
        for(i = 0; i < sourceSymbolKeys.length; i++){
            key = sourceSymbolKeys[i];
            if (excluded.indexOf(key) >= 0) continue;
            if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue;
            target[key] = source[key];
        }
    }
    return target;
}
function _object_without_properties_loose(source, excluded) {
    if (source == null) return {};
    var target = {};
    var sourceKeys = Object.keys(source);
    var key, i;
    for(i = 0; i < sourceKeys.length; i++){
        key = sourceKeys[i];
        if (excluded.indexOf(key) >= 0) continue;
        target[key] = source[key];
    }
    return target;
}
function _sliced_to_array(arr, i) {
    return _array_with_holes(arr) || _iterable_to_array_limit(arr, i) || _unsupported_iterable_to_array(arr, i) || _non_iterable_rest();
}
function _unsupported_iterable_to_array(o, minLen) {
    if (!o) return;
    if (typeof o === "string") return _array_like_to_array(o, minLen);
    var n = Object.prototype.toString.call(o).slice(8, -1);
    if (n === "Object" && o.constructor) n = o.constructor.name;
    if (n === "Map" || n === "Set") return Array.from(n);
    if (n === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(n)) return _array_like_to_array(o, minLen);
}
function _ts_generator(thisArg, body) {
    var f, y, t, g, _ = {
        label: 0,
        sent: function() {
            if (t[0] & 1) throw t[1];
            return t[1];
        },
        trys: [],
        ops: []
    };
    return g = {
        next: verb(0),
        "throw": verb(1),
        "return": verb(2)
    }, typeof Symbol === "function" && (g[Symbol.iterator] = function() {
        return this;
    }), g;
    function verb(n) {
        return function(v) {
            return step([
                n,
                v
            ]);
        };
    }
    function step(op) {
        if (f) throw new TypeError("Generator is already executing.");
        while(_)try {
            if (f = 1, y && (t = op[0] & 2 ? y["return"] : op[0] ? y["throw"] || ((t = y["return"]) && t.call(y), 0) : y.next) && !(t = t.call(y, op[1])).done) return t;
            if (y = 0, t) op = [
                op[0] & 2,
                t.value
            ];
            switch(op[0]){
                case 0:
                case 1:
                    t = op;
                    break;
                case 4:
                    _.label++;
                    return {
                        value: op[1],
                        done: false
                    };
                case 5:
                    _.label++;
                    y = op[1];
                    op = [
                        0
                    ];
                    continue;
                case 7:
                    op = _.ops.pop();
                    _.trys.pop();
                    continue;
                default:
                    if (!(t = _.trys, t = t.length > 0 && t[t.length - 1]) && (op[0] === 6 || op[0] === 2)) {
                        _ = 0;
                        continue;
                    }
                    if (op[0] === 3 && (!t || op[1] > t[0] && op[1] < t[3])) {
                        _.label = op[1];
                        break;
                    }
                    if (op[0] === 6 && _.label < t[1]) {
                        _.label = t[1];
                        t = op;
                        break;
                    }
                    if (t && _.label < t[2]) {
                        _.label = t[2];
                        _.ops.push(op);
                        break;
                    }
                    if (t[2]) _.ops.pop();
                    _.trys.pop();
                    continue;
            }
            op = body.call(thisArg, _);
        } catch (e) {
            op = [
                6,
                e
            ];
            y = 0;
        } finally{
            f = t = 0;
        }
        if (op[0] & 5) throw op[1];
        return {
            value: op[0] ? op[1] : void 0,
            done: true
        };
    }
}
import { sdkLogger } from '../../../logger';
export var ShakaThumbnailProvider = /*#__PURE__*/ function() {
    "use strict";
    function ShakaThumbnailProvider() {
        var _this = this;
        _class_call_check(this, ShakaThumbnailProvider);
        _define_property(this, "logger", sdkLogger.withContext('Shaka Thumbnail Provider'));
        _define_property(this, "player", void 0);
        _define_property(this, "shakaHandler", void 0);
        _define_property(this, "thumbnailVariants", []);
        _define_property(this, "isLive", function() {
            var _this_shakaHandler;
            return Boolean((_this_shakaHandler = _this.shakaHandler) === null || _this_shakaHandler === void 0 ? void 0 : _this_shakaHandler.isLive());
        });
    }
    _create_class(ShakaThumbnailProvider, [
        {
            key: "providePlayer",
            value: function providePlayer(player) {
                var _this = this;
                var _this_player;
                this.player = player;
                if ((_this_player = this.player) === null || _this_player === void 0 ? void 0 : _this_player.getThumbnailVariants) {
                    var _this1 = this;
                    // This is our custom API brought to shaka fork before official implementation.
                    // It's not available anymore on shaka v4, and is only used with v3.0.5 because 3.0.5
                    // does not have getImageTracks().
                    // Shaka 3.3.10 still supports getThumbnailVariants(). Because getImageTracks() fetches
                    // incorrect thumbnails with 3.3.10, we will use the older API with 3.3.10 until there
                    // is a permanent fix. See https://gspcloud.atlassian.net/browse/VPTJS-12680
                    this.shakaHandler = {
                        isLive: function() {
                            var _this_player;
                            var _this_player_isLive;
                            return (_this_player_isLive = (_this_player = _this.player) === null || _this_player === void 0 ? void 0 : _this_player.isLive()) !== null && _this_player_isLive !== void 0 ? _this_player_isLive : false;
                        },
                        getThumbnailVariants: function() {
                            var _this_player;
                            var _this_player_getThumbnailVariants;
                            return (_this_player_getThumbnailVariants = (_this_player = _this.player) === null || _this_player === void 0 ? void 0 : _this_player.getThumbnailVariants()) !== null && _this_player_getThumbnailVariants !== void 0 ? _this_player_getThumbnailVariants : [];
                        },
                        getThumbnailStream: /*#__PURE__*/ function() {
                            var _ref = _async_to_generator(function(variantId) {
                                var _this_player, _this_player1, chosenVariant, shakaThumbnailStream;
                                return _ts_generator(this, function(_state) {
                                    switch(_state.label){
                                        case 0:
                                            chosenVariant = (_this_player = _this1.player) === null || _this_player === void 0 ? void 0 : _this_player.getThumbnailVariants().find(function(v) {
                                                return v.id === variantId;
                                            });
                                            if (!chosenVariant) {
                                                return [
                                                    2,
                                                    null
                                                ];
                                            }
                                            return [
                                                4,
                                                (_this_player1 = _this1.player) === null || _this_player1 === void 0 ? void 0 : _this_player1.selectThumbnailVariant(chosenVariant)
                                            ];
                                        case 1:
                                            shakaThumbnailStream = _state.sent();
                                            if (!shakaThumbnailStream) {
                                                return [
                                                    2,
                                                    null
                                                ];
                                            }
                                            return [
                                                2,
                                                _this1.adaptShakaThumbnailStream(shakaThumbnailStream)
                                            ];
                                    }
                                });
                            });
                            return function(variantId) {
                                return _ref.apply(this, arguments);
                            };
                        }()
                    };
                } else {
                    var _this2 = this;
                    // This is the official Shaka API that we use with Shaka v4.2+
                    this.shakaHandler = {
                        isLive: function() {
                            var _this_player;
                            var _this_player_isLive;
                            return (_this_player_isLive = (_this_player = _this.player) === null || _this_player === void 0 ? void 0 : _this_player.isLive()) !== null && _this_player_isLive !== void 0 ? _this_player_isLive : false;
                        },
                        getThumbnailVariants: function() {
                            var _this_player;
                            _this.logger.verbose('Using getImageTracks() to fetch thumbnails');
                            var _this_player_getImageTracks;
                            var imageTracks = (_this_player_getImageTracks = (_this_player = _this.player) === null || _this_player === void 0 ? void 0 : _this_player.getImageTracks()) !== null && _this_player_getImageTracks !== void 0 ? _this_player_getImageTracks : [];
                            return imageTracks.map(function(imageTrack) {
                                return {
                                    id: imageTrack.id.toString(),
                                    thumbnailWidth: imageTrack.width,
                                    thumbnailHeight: imageTrack.height
                                };
                            });
                        },
                        getThumbnailStream: /*#__PURE__*/ function() {
                            var _ref = _async_to_generator(function(variantId, liveThumbnailWindow) {
                                return _ts_generator(this, function(_state) {
                                    return [
                                        2,
                                        _this2.createThumbnailStreamForWindow(variantId, liveThumbnailWindow)
                                    ];
                                });
                            });
                            return function(variantId, liveThumbnailWindow) {
                                return _ref.apply(this, arguments);
                            };
                        }()
                    };
                }
            }
        },
        {
            key: "setThumbnailVariants",
            value: function setThumbnailVariants() {
                var _this_shakaHandler;
                if (!this.player) {
                    this.handleNoPlayerProvided();
                    return;
                }
                var thumbnailVariants = (_this_shakaHandler = this.shakaHandler) === null || _this_shakaHandler === void 0 ? void 0 : _this_shakaHandler.getThumbnailVariants();
                if (thumbnailVariants) {
                    this.thumbnailVariants = thumbnailVariants;
                }
            }
        },
        {
            key: "getThumbnailVariants",
            value: function getThumbnailVariants() {
                return this.thumbnailVariants;
            }
        },
        {
            key: "getThumbnailStream",
            value: function getThumbnailStream(variantId, liveThumbnailWindow) {
                var _this = this;
                return _async_to_generator(function() {
                    return _ts_generator(this, function(_state) {
                        if (!_this.shakaHandler) return [
                            2,
                            Promise.resolve(null)
                        ];
                        return [
                            2,
                            _this.shakaHandler.getThumbnailStream(variantId, liveThumbnailWindow)
                        ];
                    });
                })();
            }
        },
        {
            key: "handleNoPlayerProvided",
            value: function handleNoPlayerProvided() {
                this.logger.warn('Shaka Player has not been provided to the thumbnail manager');
            }
        },
        {
            key: "createThumbnailStreamForWindow",
            value: function createThumbnailStreamForWindow(variantId, liveThumbnailWindow) {
                var _this = this;
                return _async_to_generator(function() {
                    var _this_player, chosenVariant, imageTrack, _imageTrack_tilesLayout_split_map, gridH, gridV, maxSegmentDuration, maxThumbnailSegmentDuration, imagesInGrid, thumbnailSegments, _liveThumbnailWindow_windowStart, position;
                    return _ts_generator(this, function(_state) {
                        switch(_state.label){
                            case 0:
                                chosenVariant = _this.thumbnailVariants.find(function(param) {
                                    var id = param.id;
                                    return id === variantId;
                                });
                                if (!chosenVariant) {
                                    return [
                                        2,
                                        null
                                    ];
                                }
                                imageTrack = (_this_player = _this.player) === null || _this_player === void 0 ? void 0 : _this_player.getImageTracks().find(function(imageTrack) {
                                    return imageTrack.id.toString() === variantId;
                                });
                                if (!imageTrack) {
                                    return [
                                        2,
                                        null
                                    ];
                                }
                                _imageTrack_tilesLayout_split_map = _sliced_to_array(imageTrack.tilesLayout.split('x').map(function(x) {
                                    return parseInt(x, 10);
                                }), 2), gridH = _imageTrack_tilesLayout_split_map[0], gridV = _imageTrack_tilesLayout_split_map[1];
                                maxSegmentDuration = imageTrack.maxSegmentDuration || 0;
                                maxThumbnailSegmentDuration = 0;
                                imagesInGrid = gridH * gridV;
                                thumbnailSegments = [];
                                position = (_liveThumbnailWindow_windowStart = liveThumbnailWindow === null || liveThumbnailWindow === void 0 ? void 0 : liveThumbnailWindow.windowStart) !== null && _liveThumbnailWindow_windowStart !== void 0 ? _liveThumbnailWindow_windowStart : 0;
                                if (!position) return [
                                    3,
                                    2
                                ];
                                return [
                                    4,
                                    _this.addThumbnailSegmentForLiveWindow(imageTrack.id, position, thumbnailSegments)
                                ];
                            case 1:
                                maxThumbnailSegmentDuration = _state.sent();
                                return [
                                    3,
                                    4
                                ];
                            case 2:
                                return [
                                    4,
                                    _this.addAllThumbnailsSegments(imageTrack.id, thumbnailSegments)
                                ];
                            case 3:
                                maxThumbnailSegmentDuration = _state.sent();
                                _state.label = 4;
                            case 4:
                                if (maxThumbnailSegmentDuration > maxSegmentDuration) {
                                    maxSegmentDuration = maxThumbnailSegmentDuration;
                                }
                                return [
                                    2,
                                    _object_spread_props(_object_spread({}, chosenVariant), {
                                        bandwidth: imageTrack.bandwidth,
                                        tileWidth: imageTrack.width * gridH,
                                        tileHeight: imageTrack.height * gridV,
                                        maxHorizontalThumbnailCount: gridH,
                                        maxVerticalThumbnailCount: gridV,
                                        maxSegmentDuration: maxSegmentDuration,
                                        thumbnailDuration: maxSegmentDuration / imagesInGrid,
                                        thumbnailSegments: thumbnailSegments
                                    })
                                ];
                        }
                    });
                })();
            }
        },
        {
            key: "addThumbnailSegmentForLiveWindow",
            value: function addThumbnailSegmentForLiveWindow(imageTrackId, position, thumbnailSegments) {
                var _this = this;
                return _async_to_generator(function() {
                    var _this_player, duration, thumbnail, segment, segmentStartTime;
                    return _ts_generator(this, function(_state) {
                        switch(_state.label){
                            case 0:
                                duration = 0;
                                return [
                                    4,
                                    (_this_player = _this.player) === null || _this_player === void 0 ? void 0 : _this_player.getThumbnails(imageTrackId, position)
                                ];
                            case 1:
                                thumbnail = _state.sent();
                                if (thumbnail) {
                                    segment = thumbnail.segment;
                                    segmentStartTime = segment.getStartTime();
                                    duration = segment.getEndTime() - segmentStartTime;
                                    thumbnailSegments.push({
                                        tileUrl: thumbnail.uris[0],
                                        startPosition: segmentStartTime,
                                        duration: duration
                                    });
                                }
                                return [
                                    2,
                                    duration
                                ];
                        }
                    });
                })();
            }
        },
        {
            key: "addAllThumbnailsSegments",
            value: function addAllThumbnailsSegments(imageTrackId, thumbnailSegments) {
                var _this = this;
                return _async_to_generator(function() {
                    var _this_player, maxThumbnailSegmentDuration, thumbnails, _iteratorNormalCompletion, _didIteratorError, _iteratorError, _iterator, _step, thumbnail, length, segment, segmentStartTime, duration;
                    return _ts_generator(this, function(_state) {
                        switch(_state.label){
                            case 0:
                                maxThumbnailSegmentDuration = 0;
                                return [
                                    4,
                                    (_this_player = _this.player) === null || _this_player === void 0 ? void 0 : _this_player.getAllThumbnails(imageTrackId)
                                ];
                            case 1:
                                thumbnails = _state.sent();
                                if (thumbnails) {
                                    _iteratorNormalCompletion = true, _didIteratorError = false, _iteratorError = undefined;
                                    try {
                                        for(_iterator = thumbnails[Symbol.iterator](); !(_iteratorNormalCompletion = (_step = _iterator.next()).done); _iteratorNormalCompletion = true){
                                            thumbnail = _step.value;
                                            length = thumbnailSegments.length;
                                            segment = thumbnail.segment;
                                            segmentStartTime = segment.getStartTime();
                                            if (length === 0 || thumbnailSegments[length - 1].startPosition !== segmentStartTime) {
                                                duration = segment.getEndTime() - segmentStartTime;
                                                thumbnailSegments.push({
                                                    tileUrl: thumbnail.uris[0],
                                                    startPosition: segmentStartTime,
                                                    duration: duration
                                                });
                                                if (duration > maxThumbnailSegmentDuration) {
                                                    maxThumbnailSegmentDuration = duration;
                                                }
                                            }
                                        }
                                    } catch (err) {
                                        _didIteratorError = true;
                                        _iteratorError = err;
                                    } finally{
                                        try {
                                            if (!_iteratorNormalCompletion && _iterator.return != null) {
                                                _iterator.return();
                                            }
                                        } finally{
                                            if (_didIteratorError) {
                                                throw _iteratorError;
                                            }
                                        }
                                    }
                                }
                                return [
                                    2,
                                    maxThumbnailSegmentDuration
                                ];
                        }
                    });
                })();
            }
        },
        {
            key: "adaptShakaThumbnailStream",
            value: function adaptShakaThumbnailStream(shakaThumbnailStream) {
                var tileCount = shakaThumbnailStream.tileCount, rest = _object_without_properties(shakaThumbnailStream, [
                    "tileCount"
                ]);
                var splitTileCount = tileCount.split('x');
                var horizontalThumbnails = parseInt(splitTileCount[0], 10);
                var verticalThumbnails = parseInt(splitTileCount[1], 10);
                var thumbnailDuration = shakaThumbnailStream.maxSegmentDuration / (horizontalThumbnails * verticalThumbnails);
                return _object_spread_props(_object_spread({}, rest), {
                    thumbnailHeight: shakaThumbnailStream.thumbnailHeight,
                    thumbnailWidth: shakaThumbnailStream.thumbnailWidth,
                    thumbnailDuration: thumbnailDuration,
                    maxHorizontalThumbnailCount: horizontalThumbnails,
                    maxVerticalThumbnailCount: verticalThumbnails
                });
            }
        }
    ]);
    return ShakaThumbnailProvider;
}();

//# sourceMappingURL=shaka-thumbnail-provider.js.map